import React, { useState } from "react";
import PrimeButton from "../../../../components/PrimeButton";
import Modal from "../../../../components/modal";



const ModalChilds = ({ images = [] }) => {
  // const mainstate = 
  const [selectedImage, setSelectedImage] = useState(images ? images[0] : null);
  
  // console.log(images)
  return (
    <div className="w-full flex flex-col md:flex-row items-start gap-2">
      {/* Main Image Section */}
      <div className="h-48 md:h-96 w-full flex items-center justify-center md:w-2/4 ">
        <img
          src={selectedImage}
          alt="Product"
          className="h-full rounded-md"
        />
      </div>

      {/* Thumbnail Images Section */}
      <div className="flex flex-wrap justify-s md:justify-start items-start gap-3 h-full md:w-2/4 p-2">
        {images.map((img, index) => (
          <div
            key={index}
            className="relative cursor-pointer rounded-md"
            onClick={() => setSelectedImage(img)}
          >
            <img
              src={img}
              alt={`Product${index + 1}`}
              className={`w-16 h-16 md:w-24 md:h-24 rounded-md object-cover ${
                selectedImage === img ? "outline" : ""
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};


const DetailsDescription = ({images = [] , name="" , subname="" , Features=[]}) => {




  const [selectedImage, setSelectedImage] = useState(images[0]);


console.log(images)

  return (
    <div className="App mt-40  w-full">
      <div className="App-header md:px-20 px-5">
        <div>
          <div className="p-4 lg:max-w-full max-w-lg mx-auto ">
            <div className="grid items-start grid-cols-1 md:grid-cols-2 gap-4 max-lg:gap-12">
              <div className="w-full lg:sticky top-0 sm:flex gap-4 mx-2 md:mx-12">
                <div className="hidden lg:block sm:space-y-3 w-16 max-sm:w-12max-sm:mb-4 max-sm:gap-4 h-full">
                  {images.slice(0, 5).map((img, index) => (
                    <div
                      key={index}
                      className="relative w-full cursor-pointer rounded-md "
                      onClick={() => setSelectedImage(img)}
                    >
                      <img
                        src={img}
                        alt={`Product${index + 1}`}
                        className={`w-full h-full rounded-md object-cover ${
                          selectedImage === img ? "outline" : ""
                        }`}
                      />
                      {index === 4 && images.length > 5 && (
                        <Modal
                          OpenStyler={
                            <div className="md:absolute relative inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-md">
                              <span className="text-white text-lg font-bold">
                                +{images.length - 4}
                              </span>
                            </div>
                          }
                          children={<ModalChilds images={images}/>}
                          width={1000}
                        />
                      )}
                    </div>
                  ))}
                </div>





                <img
                  src={selectedImage}
                  alt="Product"
                  className="md:w-[30vw] w-full rounded-md object-cover "
                  style={{ aspectRatio: "1/1" }}
                />

                {/* mobile view */}
                <div className="flex lg:hidden mt-5 gap-4  h-full">
                  {images.slice(0, 5).map((img, index) => (
                    <div
                      key={index}
                      className="relative w-full cursor-pointer rounded-md"
                      onClick={() => setSelectedImage(img)}
                    >
                      <img
                        src={img}
                        alt={`Product${index + 1}`}
                        className={`w-full h-full rounded-md object-cover ${
                          selectedImage === img ? "outline" : ""
                        }`}
                      />
                      {index === 4 && images.length > 5 && (
                        <>
                          <Modal
                            OpenStyler={
                              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-md">
                                <span className="text-white text-lg font-bold">
                                  +{images.length - 4}
                                </span>
                              </div>
                            }
                            children={<ModalChilds images={images}/>}
                            title=""
                          />
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>




              <div className="mt-10">
                <h3 className="text-[32px] font-bold text-[#1E1E1E] text-left">
                  {name}
                </h3>
                <div className="flex flex-wrap gap-4">
                  <p className="text-gray-400 text-xl">
                    <span className="text-sm ml-1.5">
                      {" "}
                      {subname}{" "}
                    </span>
                  </p>
                </div>

                <div className="mt-5">
                  <h3 className="text-[20px] font-[500] text-gray-800 text-left ">
                    Features:
                  </h3>
                  <ul className="space-y-3 list-disc mt-4 pl-4 text-sm text-gray-800">
                    {Features.map((detail, index) => (
                      <li className="flex items-start text-left" key={index}>
                        <svg
                          className="w-4 h-4 mr-2 text-primary-color flex-shrink-0"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                        </svg>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex items-start mt-10">
                  <PrimeButton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsDescription;
